import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Google Analytics 4 — propiedad "Noor Passport Services" (creada 2026-10-23).
// 2026-10-23 (decisión de Manuel): SIN banner. En EE. UU. no hay obligación legal de pedir
// consentimiento para una analítica básica; basta avisarlo en la Política de Privacidad.
// (Si algún día se atiende público de la UE/Reino Unido, habría que volver a poner banner.)
// Reglas de privacidad:
//  - Se respeta la señal "No rastrear" (DNT) y Global Privacy Control del navegador:
//    si están activas, no se carga nada de Google.
//  - Solo se envía la ruta de la página (sin parámetros de la URL), para que ningún dato
//    personal pueda viajar en un enlace.
//  - IP anonimizada y sin señales de publicidad.
// El nombre del archivo se conserva (ConsentAnalytics) para no tocar App.tsx.
const GA_ID = 'G-38RL16XLBB';
function privacySignalOn(): boolean {
  try {
    const n = navigator as any;
    return n.doNotTrack === '1' || (window as any).doNotTrack === '1' || n.globalPrivacyControl === true;
  } catch {
    return false;
  }
}
let gaLoaded = false;
function loadGA() {
  if (gaLoaded || typeof window === 'undefined') return;
  gaLoaded = true;
  const w = window as any;
  w.dataLayer = w.dataLayer || [];
  w.gtag = function () {
    w.dataLayer.push(arguments);
  };
  w.gtag('consent', 'default', {
    analytics_storage: 'granted',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied'
  });
  w.gtag('js', new Date());
  w.gtag('config', GA_ID, {
    send_page_view: false,
    anonymize_ip: true,
    allow_google_signals: false,
    allow_ad_personalization_signals: false
  });
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
}
function sendPageView(pathname: string) {
  const w = window as any;
  if (!gaLoaded || !w.gtag) return;
  w.gtag('event', 'page_view', {
    page_path: pathname,
    page_location: window.location.origin + pathname,
    page_title: document.title
  });
}
export function ConsentAnalytics() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    if (privacySignalOn()) return;
    loadGA();
    const key = pathname.length > 1 ? pathname.replace(/\/+$/, '') : '/';
    // El título de la página se actualiza en otro efecto; esperamos un instante.
    const t = window.setTimeout(() => sendPageView(key), 150);
    return () => window.clearTimeout(t);
  }, [pathname]);
  return null;
}